<template>
    <div
        class="px-[2.03vw] pb-[156.14px] xs:px-2 sm:pb-[168.54px] md:pb-[190px] lg:pb-[166px]"
    >
        <h5 class="slt-h5 mb-[5.09vw] xs:mb-5">
            {{ t("news.post.fastlink") }}
        </h5>
        <ul class="slt-body-1 -ml-4 flex flex-col gap-[3.05vw] xs:gap-3">
            <li v-for="data in fastlinkData" :key="data.name">
                <NuxtLink
                    class="btn flex w-fit items-center gap-[3.05vw] rounded-full py-1 pl-4 pr-5 transition-all duration-300 ease-in-out xs:gap-3 sm:hover:bg-base-white"
                    :to="$localePath(data.link)"
                    :external="data.type === 'external'"
                    :target="data.type === 'external' ? '_blank' : '_self'"
                >
                    <div class="btn__arrow__group">
                        <SvgArrowForward20
                            :color="'black'"
                            class="btn__arrow btn__arrow--main"
                        />
                        <SvgArrowForward20
                            :color="'black'"
                            class="btn__arrow btn__arrow--hover"
                        />
                    </div>
                    <p>
                        <span
                            v-for="text in data.name"
                            :key="text"
                            class="block"
                        >
                            {{ text }}
                        </span>
                    </p>
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>
<script setup>
const nuxtApp = useNuxtApp();
const { fetchPage } = useFetchAPI();
const { t, locale } = useI18n();

const searchData = computed(() => {
    return (
        nuxtApp.payload.data?.["fetchPage-search"]?.[locale.value] ||
        nuxtApp.payload.data?.["fetchPage-search"]?.zh
    );
});

if (!searchData.value) await fetchPage("search");

const fastlinkData = computed(() => {
    return searchData.value?.meta_box?.fastLinks.data;
});
</script>

<style scoped>
/* button arrow animation */
.btn__arrow__group {
    @apply relative inline-block h-[5.09vw] w-[5.09vw] overflow-hidden align-middle xs:h-[20px] xs:w-[20px];
}
.btn__arrow {
    @apply absolute right-0 top-0 size-full;
    transition:
        transform 0.3s cubic-bezier(0.17, 0.67, 0.3, 1.33),
        opacity 0.3s cubic-bezier(0.17, 0.67, 0.3, 1.33);
}
.btn__arrow--hover {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
}

@media (min-width: 640px) {
    .btn:hover .btn__arrow--main {
        transform: translate3d(100%, 0, 0);
        opacity: 0;
    }
    .btn:hover .btn__arrow--hover {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
}
</style>
